import React, { useEffect, useState } from 'react';
import LinkService from '../system/LinkService';
import useApiCall from '../system/useApiCall';
import StandardTable from '../common/Component/StandardTable';
import { GridColumns, GridRowsProp } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography/Typography';
import ChannelPointsRewardsTO from './ChannelPointsRewardsTO';
import { useSnackbar } from 'notistack';

export default function ChannelPointsRewardsControllPage() {
  const { enqueueSnackbar } = useSnackbar();
  const [controlList, setControlList] = useState<ChannelPointsRewardsTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCall = useApiCall();

  useEffect(() => {
    getChannelPointsRewardsAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const numberRangeValidator = (min: number, max: number) => (params: any) => {
    const value = Number(params.props.value);
    const hasError = Number.isNaN(value) || value < min || value > max;

    return {
      ...params.props,
      error: hasError,
    };
  };

  const syncChannelPointsReward = () => {
    apiCall.get(LinkService.channelPointsRewardsSync(), "Sync angestoßen...").then((data) => {});
  }

  const getChannelPointsRewardsAll = () => {
    setIsLoading(true);
    apiCall.get(LinkService.channelPointsRewardsAll()).then((data) => {
      if (data) {
        let i:number = 1;
        for (const reward of data) {
          reward.id = i;
          i++;
        }
        const list: ChannelPointsRewardsTO[] = data;
        setControlList(list);
        setIsLoading(false);
      }
    });
  };

  const columns: GridColumns = [
    { field: 'id', headerName: 'ID', type: 'number', editable: false, hide: true },
    { field: 'title', headerName: 'Titel', flex: 3, editable: false, type: 'string' },
    { field: 'cost', headerName: 'Kosten', flex: 1, editable: true, type: 'number', preProcessEditCellProps: numberRangeValidator(1, 5000000) },
    { field: 'isEnabled', headerName: 'Aktiv?', flex: 1, editable: false, type: 'boolean' },
    { field: 'isGlobalCooldownEnabled', headerName: 'Globaler Cooldown', flex: 1, editable: true, type: 'boolean' },
    { field: 'globalCooldownSeconds', headerName: 'Globaler Cooldown (Sekunden)', flex: 1, editable: true, type: 'number', preProcessEditCellProps: numberRangeValidator(1, 36000) },
    { field: 'isMaxPerStreamEnabled', headerName: 'Maximal pro Stream', flex: 1, editable: true, type: 'boolean' },
    { field: 'maxPerStream', headerName: 'Maximal pro Stream (Anzahl)', flex: 1, editable: true, type: 'number', preProcessEditCellProps: numberRangeValidator(1, 100000) },
    { field: 'isMaxPerUserPerStreamEnabled', headerName: 'Maximal pro Benutzer pro Stream', flex: 1, editable: true, type: 'boolean' },
    { field: 'maxPerUserPerStream', headerName: 'Maximal pro Benutzer pro Stream (Anzahl)', flex: 1, editable: true, type: 'number', preProcessEditCellProps: numberRangeValidator(1, 100000) },
  ];

  const rows: GridRowsProp = [...controlList];

  return (
    <div>
      <Typography component='p' variant='caption'>
        Werte mit Doppelklick editieren.
      </Typography>
      <StandardTable
        saveURL={LinkService.channelPointsRewardsPost()}
        columns={columns}
        rows={rows}
        isLoading={isLoading}
        hideActions
        hideToolbar
        extraButtonFunction={syncChannelPointsReward}
        extraButtonText="Mit Twitch synchronisieren"
      />
    </div>
  );
}
